import { ChevronLeftIcon } from "@heroicons/react/solid";
import Countdown from "components/Countdown";
import { type ReactNode } from "react";

const PageHeader = ({
  title,
  subtitle,
  children,
  onBack,
  expires,
  onExpire,
}: {
  expires?: Date;
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onExpire?: () => void;
  children?: ReactNode;
}) => {
  const padding = subtitle ? "py-2" : onBack ? "py-2.5" : "py-5";

  return (
    <header className="flex items-center justify-between bg-white px-4 shadow">
      <div className={`flex items-center space-x-4 ${padding}`}>
        {onBack ? (
          <button
            className="rounded-full p-2 hover:bg-gray-200"
            onClick={() => {
              onBack();
            }}
          >
            <ChevronLeftIcon className="h-5 w-5" />
          </button>
        ) : null}
        <div>
          <h1 className="text-md font-semibold leading-tight">{title}</h1>
          {subtitle ? <p className="text-xs text-gray-400">{subtitle}</p> : null}
        </div>
      </div>
      {expires ? (
        <div className="hidden bg-gray-100 px-14 py-2 sm:flex sm:flex-col sm:items-center sm:justify-center">
          <Countdown expireDate={expires} onExpire={() => onExpire?.()} />
        </div>
      ) : null}
      <div className={padding}>{children}</div>
    </header>
  );
};

export default PageHeader;
